import * as React from 'react';
import {Grid} from '@mui/material';
import {InsertDriveFileOutlined} from '@mui/icons-material';
import type {ApprovalRequestFile} from '../../generated-api';
import {decimalNumber} from '../../helpers/number';

/**
 * One cell of the four-column user row. When the space does not collect the
 * attribute the cell is kept (empty) on desktop, so the remaining fields stay in
 * their designed columns and the next block cannot slide up into the same row.
 * On mobile the columns are stacked, so the empty cell is dropped instead.
 */
export const UserAttributeCell = ({show, children}: { show?: boolean, children: React.ReactNode }) =>
    <Grid size={{xs: 12, md: 3}} sx={show ? undefined : {display: {xs: 'none', md: 'block'}}}>
        {show ? children : null}
    </Grid>;

const fileSize = (size?: number) => {
    if (!size && size !== 0) {
        return '';
    }
    return size < 1024 * 1024
        ? decimalNumber(size / 1024, 0, 0) + ' kB'
        : decimalNumber(size / (1024 * 1024), 1, 1) + ' MB';
};

export const ApprovalFileRow = ({file}: { file: ApprovalRequestFile }) => <div
    className={'tw-flex tw-items-center tw-gap-8 tw-border tw-border-solid tw-rounded-md tw-p-8 tw-mt-4'}
    style={{borderColor: 'var(--color-black-inactive)'}}>
    <InsertDriveFileOutlined fontSize={'small'}/>
    <a href={file.download_url} target={'_blank'} rel={'noreferrer'} className={'tw-grow'}>
        {file.file_name}
    </a>
    <span style={{fontSize: '12px', color: 'var(--color-black-inactive)'}}>{fileSize(file.size)}</span>
</div>;
